import styles from "./Sidebar.module.scss";
import { useIntl } from "react-intl";
import Logo from "./logo/Logo.tsx";
import NavLinks from "./NavLinks.tsx";
import Footer from "./Footer.tsx";
import GrayButtonList from "./GrayButtonList.tsx";
import { clsx } from "clsx";

export default function Sidebar({
  isSidebarExpandable,
}: {
  isSidebarExpandable: boolean;
}) {
  const intl = useIntl();

  return (
    <div
      className={styles.container}
      role="region"
      aria-label={intl.formatMessage({ defaultMessage: "Sidebar" })}
    >
      <div className={styles.logoArea}>
        <Logo />
      </div>
      <NavLinks isSidebarExpandable={isSidebarExpandable} />
      <div className={styles.stickyBottom}>
        <GrayButtonList
          className={styles.links}
          linkClassName={clsx(
            "vst-button-rectangle",
            "vst-button-size-small",
            "vst-button-variant-frost"
          )}
        />
        <div className={styles.footerArea}>
          <Footer />
        </div>
      </div>
    </div>
  );
}
